import { observer } from "owa-mobx-react";
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing ContextualMenu from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Menu from '@fluentui/react-components' instead. */
import { ContextualMenu } from "@fluentui/react";
import React from "react";
import { createPortal } from "owa-react-dom";
import { onNativeContextMenuDismiss } from "../utils/nativeContextMenuEventHandlers";
import getNativeContextMenuStateStore from "../store/store";

// Native Context Menu is only enabled on Monarch
function NativeContextMenu() {
    const store = getNativeContextMenuStateStore();
    
    // When the native context menu is re-opended on a different window (e.g. a popup) is not getting rendered properly sometimes,
    // so we need to unmount it so that it gets the correct target window every time is displayed.
    if (!store.showContextMenu) {
        return null;
    }
    
    return createPortal(<ContextualMenu items={store.contextualMenuItems} hidden={!store.showContextMenu} target={store.point} onDismiss={onNativeContextMenuDismiss} doNotLayer={true}/>, document.body);
}

const defaultExport: React.FunctionComponent = observer(NativeContextMenu, "NativeContextMenu");
export default defaultExport;
